import React from 'react';
import { Modal, Button, Form, Input } from 'antd';
import { CrossIcon } from '@icons';
import './DeleteApprovalModal.less';

interface DeleteApprovalModalProps {
  visible: boolean;
  approvalWorkflowName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteApprovalModal(props: DeleteApprovalModalProps) {
  const { visible, approvalWorkflowName, onCancel, onConfirm } = props;
  const [form] = Form.useForm();
  return (
    <Modal
      open={visible}
      footer={null}
      centered={true}
      closeIcon={<CrossIcon />}
      destroyOnClose
      width={500}
      zIndex={1010}
      onCancel={(e) => {
        e.stopPropagation();
        onCancel();
      }}
      className="delete-approval-modal"
    >
      <div className="modal_container" onClick={(e) => e.stopPropagation()}>
        <Form form={form} onFinish={onConfirm} layout="vertical">
          <h2
            className="modal_container__title"
            style={{ fontSize: 22, marginBottom: '0.5em' }}
          >
            Delete approval
          </h2>
          <p className="modal_container__subtitle">
            You will lose all data entered into{' '}
            <span className="delete-approval-modal__name">
              {approvalWorkflowName}
            </span>{' '}
            approval routing. Are you sure you want to delete all approval
            stages and data?
          </p>
          <Form.Item
            label="Please type “Delete” to confirm"
            name="text"
            rules={[
              { required: true, message: 'Please, type “Delete” to confirm".' },
              () => ({
                validator(_, value) {
                  if (!value || value === 'Delete') {
                    return Promise.resolve();
                  }
                  return Promise.reject('Please, type “Delete” to confirm');
                }
              })
            ]}
          >
            <Input placeholder="Delete" size="large" />
          </Form.Item>
          <div className="modal_container__actions">
            <Button
              type="text"
              size="large"
              style={{
                marginRight: '16px',
                border: 'none',
                height: 48,
                padding: '8px 32px'
              }}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              onClick={(e) => e.stopPropagation()}
              style={{ width: 216, height: 48, padding: '8px 15px' }}
            >
              Delete
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
